import {
    ItemConfiguracao,
    ParametroEntradaInstalacaoProduto,
    ItemConfiguracaoProduto,
    ParametroEntradaTransmissaoComProduto
} from './../../../model/catalogo';
import {FtaService} from './../../../service/fta.service';
import {GlobalService} from './../../../service/global.service';
import {Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Router, ActivatedRoute} from '@angular/router';


@Component({
    selector: 'app-cadastro-produto-transmissao',
    templateUrl: './cadastro-produto-transmissao.component.html',
    styleUrls: ['./cadastro-produto-transmissao.component.css']
})
export class CadastroProdutoTransmissaoComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public globalService: GlobalService,
        public ftaService: FtaService
    ) {
        this.tipoDado = [
            {codTipoDado: null, labelTipoDado: ''},
            {codTipoDado: 'string', labelTipoDado: 'string'},
            {codTipoDado: 'integer', labelTipoDado: 'integer'},
            {codTipoDado: 'decimal', labelTipoDado: 'decimal'},
            {codTipoDado: 'boolean', labelTipoDado: 'boolean'}
        ];

        this.subTipoDado = [
            {codSubTipoDado: null, labelSubTipoDado: ''},
            {codSubTipoDado: 'array', labelSubTipoDado: 'array'},
            {codSubTipoDado: 'password', labelSubTipoDado: 'password'},
            {codSubTipoDado: 'sel_excl', labelSubTipoDado: 'sel_excl'},
            {codSubTipoDado: 'sel_mult', labelSubTipoDado: 'sel_mult'}
        ];

        this.obrigatorio = [
            {codObrigatorio: null, labelObrigatorio: ''},
            {codObrigatorio: true, labelObrigatorio: 'Sim'},
            {codObrigatorio: false, labelObrigatorio: 'Não'}
        ];
    }

    tipoOperacao: string;
    nomeProduto: string;
    resultado: ItemConfiguracao = new ItemConfiguracao();
    resultadoAux: ItemConfiguracao = new ItemConfiguracao();
    tituloPagina: string;

    tipoDado: any[];
    subTipoDado: any[];
    obrigatorio: any[];

    selectedTipoDado: any;
    selectedSubTipoDado: any;
    selectedObrigatorio: any;

    novoItemConfiguracao: string;


    paramsSubscription: Subscription = null;
    classeAcao: string = 'col-centered';

    ngOnInit() {

        this.paramsSubscription = this.route.params.subscribe(params => {
            if (params['nome'] != undefined && params['tipo'] != undefined) {

                this.nomeProduto = params['nome'];


                if (params['tipo'] == 'instalacao') {
                    this.tipoOperacao = 'instalacao';
                    this.tituloPagina = 'Parametros de instalação do produto - ' + this.nomeProduto;
                }

                if (params['tipo'] == 'transmissao') {
                    this.tipoOperacao = 'transmissao';
                    this.tituloPagina = 'Parametros de transmissão do produto - ' + this.nomeProduto;

                }

                if (params['tipo'] == 'cadastro') {
                    this.classeAcao = '';
                    this.tituloPagina = 'Parametros de transmissão do produto - ' + this.nomeProduto;
                    this.tipoOperacao = 'cadastro';
                    this.resultado.nome = '';
                    this.resultado.itemConfiguracaoProduto = new ItemConfiguracaoProduto();
                    this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto = new Array<ParametroEntradaInstalacaoProduto>();
                    let parametroEntradaInstalacaoProduto = new ParametroEntradaInstalacaoProduto();
                    parametroEntradaInstalacaoProduto.nome = '';
                    parametroEntradaInstalacaoProduto.descricao = '';
                    parametroEntradaInstalacaoProduto.nomeItemConfiguracaoPai = '';
                    parametroEntradaInstalacaoProduto.novoParametro = true;
                    parametroEntradaInstalacaoProduto.nomeTipoDado = null;
                    parametroEntradaInstalacaoProduto.nomeSubtipoDado = null;
                    parametroEntradaInstalacaoProduto.obrigatorio = null;

                    this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto.push(parametroEntradaInstalacaoProduto);

                }

                if (this.tipoOperacao != 'cadastro' && this.nomeProduto != '') {
                    this.getParametros();
                }

            }
        });

    }

    getParametros() {
        let filtros: Array<any> = new Array<any>();
        filtros.push(this.nomeProduto);
        this.globalService.loading = true;
        this.ftaService.buscarItemConfiguracaoProduto(filtros)
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    if (listaItens != null) {
                        this.resultado = listaItens;
                        //ordena array de paramentros
                        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.sort(function (a, b) {
                            if (a.nome < b.nome) {
                                return -1;
                            }
                            if (a.nome > b.nome) {
                                return 1;
                            }
                            return 0;
                        });
                        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.forEach(obj => obj.novoParametro = false);

                    }
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        alert('Erro ao carregar itens.');
                    }
                }
            );
    }

    alteraTipoDadoInstalacao(index) {
        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].nomeTipoDado = this.selectedTipoDado;
    }

    alteraSubTipoDadoInstalacao(index) {
        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].nomeSubtipoDado = this.selectedSubTipoDado;
    }

    alteraSubTipoDadoTrasmissao(index) {
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].nomeSubtipoDado = this.selectedSubTipoDado;
    }

    alteraTipoDadoTransmissao(index) {
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].nomeTipoDado = this.selectedTipoDado;
    }


    //parei aqui
    alteraObrigatorioInstalacao(index) {
        if (this.selectedObrigatorio == 'sim') {
            this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].obrigatorio = true;
        } else {
            this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].obrigatorio = false;
        }
    }

    alteraObrigatorioTransmissao(index) {
        if (this.selectedObrigatorio == 'sim') {
            this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].obrigatorio = true;
        } else {
            this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].obrigatorio = false;
        }
    }

    addConteudoPadrao(index) {
        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].conteudoPadrao.push('');
        // this.resultadoAux.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].conteudoPadrao.push("");
    }

    addConteudoPadraoTransmissao(index) {
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].conteudoPadrao.push('');
        // this.resultadoAux.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[index].conteudoPadrao.push("");
    }

    alteraConteudoPadrao(indiceParametro, indiceConteudoPadrao, valor) {
        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[indiceParametro].conteudoPadrao[indiceConteudoPadrao] = valor.target.value;
    }

    alteraConteudoPadraoTransmissao(indiceParametro, indiceConteudoPadrao, valor) {
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[indiceParametro].conteudoPadrao[indiceConteudoPadrao] = valor.target.value;
    }

    removeConteudoPadrao(indiceParametro, indiceConteudoPadrao) {
        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[indiceParametro].conteudoPadrao.splice(indiceConteudoPadrao, 1);
    }

    removeConteudoPadraoTransmissao(indiceParametro, indiceConteudoPadrao) {
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[indiceParametro].conteudoPadrao.splice(indiceConteudoPadrao, 1);
    }

    novo() {
        let novoParametro = new ParametroEntradaInstalacaoProduto();
        novoParametro.nome = '';
        novoParametro.descricao = '';
        novoParametro.novoParametro = true;
        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto.push(novoParametro);
    }

    novoTransmissao() {
        let novoParametro = new ParametroEntradaTransmissaoComProduto;
        novoParametro.nome = '';
        novoParametro.descricao = '';
        novoParametro.novoParametro = true;
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.push(novoParametro);
    }

    salvar(indicePametro) {
        let parametro = this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[indicePametro];
        let nomeProduto = '';
        if (this.nomeProduto == 'novo') {
            nomeProduto = this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[0].nomeItemConfiguracaoPai;
        } else {
            nomeProduto = this.nomeProduto;
        }

        let filtros: Array<any> = new Array<any>();
        filtros.push(this.nomeProduto);
        this.globalService.loading = true;
        this.ftaService.atualizaItemConfiguracaoProduto(nomeProduto, 'instalacao', parametro.nome, parametro)
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    alert('atualizado com sucesso!');

                    if (this.tipoOperacao == 'cadastro') {
                        this.router.navigate(['/produto-transmissao-arquivo']);
                    }

                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        alert('Erro ao carregar itens.');
                    }
                }
            );
    }

    salvarTransmissao(indiceParametro) {
        let parametro = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[indiceParametro];
        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[indiceParametro].novoParametro = false;
        let nomeProduto = '';
        if (this.nomeProduto == 'novo') {
            nomeProduto = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[0].nomeItemConfiguracaoPai;
        } else {
            nomeProduto = this.nomeProduto;
        }

        let filtros: Array<any> = new Array<any>();
        filtros.push(this.nomeProduto);
        this.globalService.loading = true;
        this.ftaService.atualizaItemConfiguracaoProduto(nomeProduto, 'transmissao', parametro.nome, parametro)
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    alert('atualizado com sucesso!');
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        alert('Erro ao carregar itens.');
                    }
                }
            );
    }

    removerParametro(indiceParametro, tipo) {

        let parametro = null;
        let nomeProduto = null;

        if (tipo == 'instalacao') {
            parametro = this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[indiceParametro];
            if (this.nomeProduto == 'novo') {
                nomeProduto = this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto[0].nomeItemConfiguracaoPai;
            } else {
                nomeProduto = this.nomeProduto;
            }
        } else if (tipo == 'transmissao') {
            parametro = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[indiceParametro];
            if (this.nomeProduto == 'novo') {
                nomeProduto = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[0].nomeItemConfiguracaoPai;
            } else {
                nomeProduto = this.nomeProduto;
            }
        } else {
            return alert('nenhum parametro informado.');
        }

        let filtros: Array<any> = new Array<any>();
        filtros.push(this.nomeProduto);
        this.globalService.loading = true;
        this.ftaService.removeItemConfiguracaoProduto(nomeProduto, tipo, parametro.nome)
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    if (tipo == 'instalacao') {
                        this.resultado.itemConfiguracaoProduto.parmEntradaInstalacaoProduto.splice(indiceParametro, 1);
                    } else if (tipo == 'transmissao') {
                        this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.splice(indiceParametro, 1);
                    }
                    alert('Removido com sucesso!');
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        alert('Erro ao carregar itens.');
                    }
                }
            );
    }

    voltar() {
        this.router.navigate(['/produto-transmissao-arquivo']);
    }

}



// WEBPACK FOOTER //
// ./src/app/artefato/cadastro-produto-transmissao/cadastro-produto-transmissao.component.ts